import React, { useEffect, useState, createElement } from 'react';
import { Ticket, X, User, Mail, Phone, Globe } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
declare global {
  interface Window {
    fbq: any;
  }
}
const COUNTRY_CODES = [{
  code: '+1',
  country: 'USA/Canada'
}, {
  code: '+52',
  country: 'México'
}, {
  code: '+57',
  country: 'Colombia'
}, {
  code: '+34',
  country: 'España'
}, {
  code: '+54',
  country: 'Argentina'
}, {
  code: '+56',
  country: 'Chile'
}, {
  code: '+51',
  country: 'Perú'
}, {
  code: '+593',
  country: 'Ecuador'
}, {
  code: '+58',
  country: 'Venezuela'
}, {
  code: '+502',
  country: 'Guatemala'
}, {
  code: '+503',
  country: 'El Salvador'
}, {
  code: '+504',
  country: 'Honduras'
}, {
  code: '+505',
  country: 'Nicaragua'
}, {
  code: '+506',
  country: 'Costa Rica'
}, {
  code: '+507',
  country: 'Panamá'
}, {
  code: '+591',
  country: 'Bolivia'
}, {
  code: '+595',
  country: 'Paraguay'
}, {
  code: '+598',
  country: 'Uruguay'
}, {
  code: '+1-809',
  country: 'Rep. Dominicana'
}];
export function LandingPage() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [areaCode, setAreaCode] = useState('+1');
  const [phone, setPhone] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showRegisterModal, setShowRegisterModal] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    // Load Meta Pixel
    ;
    (function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js', null, null, null);
    window.fbq('init', '754551913878347');
    window.fbq('track', 'PageView');
  }, []);
  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    if (!email || !name || !phone || isSubmitting) return;
    setIsSubmitting(true);
    try {
      await fetch('https://services.leadconnectorhq.com/hooks/HMYR0XQcpZnIeoWD2nrn/webhook-trigger/d1eada12-31ca-46fe-a334-a8ceb1286952', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          name,
          email,
          areaCode,
          phoneNumber: phone,
          fullPhone: `${areaCode}${phone}`
        })
      });
      navigate('/thank-you');
    } catch (error) {
      console.error('Error submitting form:', error);
      setIsSubmitting(false);
    }
  };
  return <div className="min-h-screen bg-black text-white font-sans overflow-x-hidden" data-id="element-11">
      {/* Meta Pixel Noscript */}
      <noscript data-id="element-12">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=754551913878347&ev=PageView&noscript=1" alt="" data-id="element-13" />
      </noscript>

      {/* Background Image Layer */}
      <div className="absolute top-0 left-0 w-full h-[400px] md:h-[600px] z-0 opacity-60" data-id="element-14">
        <img src="https://cdn.magicpatterns.com/uploads/owSR6X5Pw8KuRfkif7sGzk/6936d7f7169a421d1ba8a294.png" alt="Background Pattern" className="w-full h-full object-cover mask-image-gradient" style={{
        maskImage: 'linear-gradient(to bottom, black 0%, transparent 100%)',
        WebkitMaskImage: 'linear-gradient(to bottom, black 0%, transparent 100%)'
      }} data-id="element-15" />
      </div>

      {/* Main Content */}
      <main className="relative z-10 max-w-4xl mx-auto px-3 md:px-4 pt-4 md:pt-8 pb-12 md:pb-20 flex flex-col items-center text-center" data-id="element-16">
        {/* Hero Image (Person + Logo) */}
        <div className="w-full max-w-[320px] md:max-w-[500px] lg:max-w-[600px] mb-1 md:mb-2 animate-fade-in-up" data-id="element-17">
          <img src="https://cdn.magicpatterns.com/uploads/3Zv33jRg9628LT8boh5bKk/tmpq_fw66qj.webp" alt="Gabriel Beltran AI Infocommerce Masterclass" className="w-full h-auto drop-shadow-2xl" data-id="element-18" />
        </div>

        {/* Subtitle */}
        <h2 className="text-sm md:text-lg lg:text-xl font-bold uppercase tracking-wide mb-3 md:mb-6 text-white leading-tight px-2" data-id="element-19">
          GENERA INGRESOS CON INTELIGENCIA ARTIFICIAL
          <br className="hidden md:block" data-id="element-20" />
          SIN EXPERIENCIA, SIN SEGUIDORES
        </h2>

        {/* Date & Time */}
        <div className="mb-4 md:mb-8" data-id="element-21">
          <p className="text-lg md:text-2xl lg:text-3xl font-bold tracking-wide text-[#FDB931]" style={{
          textShadow: '0 0 20px rgba(253, 185, 49, 0.3)'
        }} data-id="element-22">
            ENERO 13 | 7PM EST (Hora Miami)
          </p>
        </div>

        {/* Main Headline */}
        <h1 className="text-base md:text-2xl lg:text-4xl xl:text-[40px] font-black uppercase leading-tight md:leading-snug mb-4 md:mb-8 max-w-5xl px-2" data-id="element-23">
          APROVECHA EL PODER DE LA INTELIGENCIA ARTIFICIAL PARA CREAR, LANZAR Y
          ESCALAR PRODUCTOS DIGITALES A 6 Y 7 CIFRAS
        </h1>

        {/* Subtext */}
        <p className="text-gray-300 text-xs md:text-base lg:text-lg mb-6 md:mb-10 max-w-3xl px-2" data-id="element-24">
          No te quedes por fuera - Regístrate{' '}
          <span className="font-bold text-white" data-id="element-25">GRATIS</span> y empieza hoy
          mismo tu camino para generar ingresos con IA.
        </p>

        {/* CTA Button (Opens Modal) */}
        <div className="w-full max-w-2xl mb-8 md:mb-16" data-id="element-26">
          <button type="button" onClick={() => setShowRegisterModal(true)} className="group relative w-full bg-gradient-to-b from-[#FDB931] to-[#D68E15] hover:from-[#FFC54D] hover:to-[#E6A02E] text-black rounded-full py-3 px-4 md:py-4 md:px-6 lg:py-6 lg:px-10 shadow-[0_0_40px_rgba(253,185,49,0.4)] transition-all duration-300 transform hover:scale-[1.02]" data-id="element-27">
            <div className="flex flex-col items-center justify-center" data-id="element-28">
              <div className="flex items-center gap-2 md:gap-3 mb-0.5 md:mb-1" data-id="element-29">
                <Ticket className="w-6 h-6 md:w-8 md:h-8 lg:w-10 lg:h-10 text-black fill-black/10" data-id="element-30" />
                <span className="text-lg md:text-2xl lg:text-4xl font-black uppercase tracking-tight" data-id="element-31">
                  ASEGURA TU CUPO GRATIS
                </span>
              </div>
              <span className="text-xs md:text-sm lg:text-base font-medium opacity-90" data-id="element-32">
                Solo 100 Cupos. Una vez lleno, se cierra el registro.
              </span>
            </div>

            {/* Shine effect */}
            <div className="absolute inset-0 rounded-full overflow-hidden" data-id="element-33">
              <div className="absolute top-0 left-[-100%] w-1/2 h-full bg-gradient-to-r from-transparent via-white/30 to-transparent skew-x-[-25deg] group-hover:animate-shine" data-id="element-34" />
            </div>
          </button>
        </div>

        {/* Free Gift Section */}
        <div className="w-full max-w-[90%] md:max-w-4xl animate-fade-in-up delay-200" data-id="element-35">
          <img src="https://cdn.magicpatterns.com/uploads/jVAX9dF4GbSmbYPnGXQPeM/tmp5djoo1mh.webp" alt="Regalo Gratis - Guía Completa de Implementación" className="w-full h-auto drop-shadow-2xl hover:scale-[1.01] transition-transform duration-500" data-id="element-36" />
        </div>
      </main>

      {/* Footer */}
      <footer className="w-full relative z-10 bg-black border-t border-gray-800" data-id="element-37">
        <div className="max-w-5xl mx-auto px-4 md:px-6 py-4 md:py-6" data-id="element-38">
          {/* Legal Disclaimer */}
          <div className="text-gray-400 text-[10px] leading-tight space-y-2 text-left" data-id="element-39">
            <p data-id="element-40">
              INFOCOMMERCE AI y todo el equipo asociado no asume responsabilidad
              por los resultados, ingresos o éxito que puedas obtener, ni
              garantiza resultados específicos. El éxito depende en parte del
              tiempo que dediques y de tu implementación de las guías,
              estrategias y soporte proporcionados. Todo el contenido,
              entrenamientos, artículos y material educativo tiene fines
              formativos únicamente y no debe interpretarse como asesoría
              financiera, legal o de inversión.
            </p>

            <p data-id="element-41">
              Aunque nuestros servicios, sistemas y productos están diseñados
              para ayudar a nuestros clientes a crear y lanzar productos
              digitales con IA, no ofrecemos garantías (explícitas o implícitas)
              sobre resultados, ventas o ingresos derivados del uso de las
              ideas, herramientas o estrategias presentadas.
            </p>

            <p data-id="element-42">
              Los testimonios compartidos corresponden a experiencias reales de
              usuarios, pero no deben considerarse como resultados típicos, ya
              que cada persona obtiene resultados diferentes según su situación
              y las acciones que decida tomar.
            </p>

            <p data-id="element-43">
              Cualquier cifra interna, ejemplo o caso de estudio mostrado tiene
              fines ilustrativos y no garantiza que tú obtendrás los mismos
              resultados.
            </p>

            <p data-id="element-44">
              Este sitio no forma parte de Google, Google Inc., Facebook/Meta o
              Meta Inc.
            </p>

            <p data-id="element-45">
              Además, este sitio no está avalado, patrocinado ni aprobado por
              Google ni Meta de ninguna manera.
            </p>
          </div>

          {/* Copyright */}
          <div className="text-center mt-4 pt-3 border-t border-gray-800" data-id="element-46">
            <p className="text-gray-600 text-[10px] mb-1" data-id="element-47">
              &copy; 2024 AI Infocommerce Masterclass. Todos los derechos
              reservados.
            </p>
            <p className="text-gray-500 text-[10px] mb-1" data-id="element-48">
              Soporte:{' '}
              <a href="mailto:support@truemarketer.com" className="text-green-500 hover:text-green-400 transition-colors" data-id="element-49">
                support@truemarketer.com
              </a>
            </p>
            <div className="flex items-center justify-center gap-4 text-[10px]" data-id="element-50">
              <button onClick={() => setShowTerms(true)} className="text-gray-500 hover:text-white transition-colors underline" data-id="element-51">
                Términos
              </button>
              <span className="text-gray-600" data-id="element-52">|</span>
              <button onClick={() => setShowPrivacy(true)} className="text-gray-500 hover:text-white transition-colors underline" data-id="element-53">
                Privacidad
              </button>
            </div>
          </div>
        </div>
      </footer>

      {/* Registration Modal */}
      {showRegisterModal && <div className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4 backdrop-blur-sm" onClick={() => setShowRegisterModal(false)} data-id="element-54">
          <div className="bg-gray-900 border border-gray-800 rounded-2xl max-w-md w-full p-6 md:p-8 relative shadow-[0_0_50px_rgba(253,185,49,0.15)]" onClick={e => e.stopPropagation()} data-id="element-55">
            <button onClick={() => setShowRegisterModal(false)} className="absolute top-4 right-4 text-gray-400 hover:text-white transition-colors p-1" data-id="element-56">
              <X className="w-6 h-6" data-id="element-57" />
            </button>

            <div className="text-center mb-6" data-id="element-58">
              <h2 className="text-2xl md:text-3xl font-black text-white mb-2 uppercase" data-id="element-59">
                Completa Tu Registro
              </h2>
              <p className="text-gray-400 text-sm" data-id="element-60">
                Ingresa tus datos para asegurar tu cupo gratuito
              </p>
            </div>

            <form onSubmit={handleSubmit} className="space-y-4" data-id="element-61">
              {/* Name Input */}
              <div className="space-y-1" data-id="element-62">
                <label className="text-xs font-bold text-gray-400 uppercase ml-2" data-id="element-63">
                  Nombre Completo
                </label>
                <div className="relative" data-id="element-64">
                  <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none" data-id="element-65">
                    <User className="h-5 w-5 text-gray-500" data-id="element-66" />
                  </div>
                  <input type="text" value={name} onChange={e => setName(e.target.value)} placeholder="Tu nombre" required className="w-full pl-12 pr-4 py-3 rounded-xl bg-white/5 border border-white/10 text-white placeholder-gray-500 focus:outline-none focus:border-[#FDB931] focus:bg-white/10 transition-all" data-id="element-67" />
                </div>
              </div>

              {/* Email Input */}
              <div className="space-y-1" data-id="element-68">
                <label className="text-xs font-bold text-gray-400 uppercase ml-2" data-id="element-69">
                  Tu Mejor Email
                </label>
                <div className="relative" data-id="element-70">
                  <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none" data-id="element-71">
                    <Mail className="h-5 w-5 text-gray-500" data-id="element-72" />
                  </div>
                  <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="ejemplo@correo.com" required className="w-full pl-12 pr-4 py-3 rounded-xl bg-white/5 border border-white/10 text-white placeholder-gray-500 focus:outline-none focus:border-[#FDB931] focus:bg-white/10 transition-all" data-id="element-73" />
                </div>
              </div>

              {/* Phone Input Group */}
              <div className="space-y-1" data-id="element-74">
                <label className="text-xs font-bold text-gray-400 uppercase ml-2" data-id="element-75">
                  WhatsApp / Teléfono
                </label>
                <div className="flex gap-2" data-id="element-76">
                  {/* Area Code Selector */}
                  <div className="relative w-1/3" data-id="element-77">
                    <div className="absolute inset-y-0 left-0 pl-2 flex items-center pointer-events-none" data-id="element-78">
                      <Globe className="h-4 w-4 text-gray-500" data-id="element-79" />
                    </div>
                    <select value={areaCode} onChange={e => setAreaCode(e.target.value)} className="w-full pl-8 pr-2 py-3 rounded-xl bg-white/5 border border-white/10 text-white focus:outline-none focus:border-[#FDB931] focus:bg-white/10 transition-all appearance-none text-sm" data-id="element-80">
                      {COUNTRY_CODES.map(country => <option key={country.code} value={country.code} className="bg-gray-900" data-id="element-81">
                          {country.code} {country.country}
                        </option>)}
                    </select>
                  </div>

                  {/* Phone Number Input */}
                  <div className="relative w-2/3" data-id="element-82">
                    <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none" data-id="element-83">
                      <Phone className="h-5 w-5 text-gray-500" data-id="element-84" />
                    </div>
                    <input type="tel" value={phone} onChange={e => setPhone(e.target.value.replace(/\D/g, ''))} placeholder="Número" required className="w-full pl-12 pr-4 py-3 rounded-xl bg-white/5 border border-white/10 text-white placeholder-gray-500 focus:outline-none focus:border-[#FDB931] focus:bg-white/10 transition-all" data-id="element-85" />
                  </div>
                </div>
              </div>

              {/* Submit Button */}
              <button type="submit" disabled={isSubmitting} className="w-full mt-6 bg-gradient-to-b from-[#FDB931] to-[#D68E15] hover:from-[#FFC54D] hover:to-[#E6A02E] disabled:opacity-50 disabled:cursor-not-allowed text-black font-black uppercase tracking-wide rounded-xl py-4 shadow-lg hover:shadow-[#FDB931]/20 transition-all duration-300 transform hover:scale-[1.02]" data-id="element-86">
                {isSubmitting ? 'PROCESANDO...' : 'CONFIRMAR REGISTRO'}
              </button>

              <p className="text-center text-xs text-gray-500 mt-4" data-id="element-87">
                Tus datos están 100% seguros y no compartiremos tu información.
              </p>
            </form>
          </div>
        </div>}

      {/* Terms Modal */}
      {showTerms && <div className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4" onClick={() => setShowTerms(false)} data-id="element-88">
          <div className="bg-gray-900 rounded-lg max-w-2xl w-full max-h-[80vh] overflow-y-auto p-6 md:p-8 relative" onClick={e => e.stopPropagation()} data-id="element-89">
            <button onClick={() => setShowTerms(false)} className="absolute top-4 right-4 text-gray-400 hover:text-white transition-colors" data-id="element-90">
              <X className="w-6 h-6" data-id="element-91" />
            </button>
            <h2 className="text-2xl md:text-3xl font-bold mb-6" data-id="element-92">
              Términos y Condiciones
            </h2>
            <div className="text-gray-300 text-sm md:text-base space-y-4 leading-relaxed" data-id="element-93">
              <p data-id="element-94">
                Al registrarte y participar en el AI Infocommerce Masterclass,
                aceptas los siguientes términos y condiciones:
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-95">
                1. Aceptación de Términos
              </h3>
              <p data-id="element-96">
                Al acceder y utilizar este sitio web y registrarte para el
                evento, aceptas estar sujeto a estos términos y condiciones,
                todas las leyes y regulaciones aplicables.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-97">
                2. Uso del Servicio
              </h3>
              <p data-id="element-98">
                El contenido proporcionado en el masterclass es solo para fines
                educativos e informativos. No garantizamos resultados
                específicos de ingresos o éxito comercial.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-99">
                3. Propiedad Intelectual
              </h3>
              <p data-id="element-100">
                Todo el contenido, materiales, y recursos proporcionados son
                propiedad de Infocommerce AI y están protegidos por derechos de
                autor. No está permitida la reproducción o distribución sin
                autorización expresa.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-101">
                4. Limitación de Responsabilidad
              </h3>
              <p data-id="element-102">
                Infocommerce AI no será responsable de ningún daño directo,
                indirecto, incidental o consecuente que resulte del uso o la
                imposibilidad de usar nuestros servicios.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-103">
                5. Modificaciones
              </h3>
              <p data-id="element-104">
                Nos reservamos el derecho de modificar estos términos en
                cualquier momento. El uso continuado del servicio después de
                cambios constituye la aceptación de los nuevos términos.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-105">Contacto</h3>
              <p data-id="element-106">
                Para preguntas sobre estos términos, contacta:{' '}
                <a href="mailto:support@truemarketer.com" className="text-green-500 hover:text-green-400" data-id="element-107">
                  support@truemarketer.com
                </a>
              </p>
            </div>
          </div>
        </div>}

      {/* Privacy Modal */}
      {showPrivacy && <div className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4" onClick={() => setShowPrivacy(false)} data-id="element-108">
          <div className="bg-gray-900 rounded-lg max-w-2xl w-full max-h-[80vh] overflow-y-auto p-6 md:p-8 relative" onClick={e => e.stopPropagation()} data-id="element-109">
            <button onClick={() => setShowPrivacy(false)} className="absolute top-4 right-4 text-gray-400 hover:text-white transition-colors" data-id="element-110">
              <X className="w-6 h-6" data-id="element-111" />
            </button>
            <h2 className="text-2xl md:text-3xl font-bold mb-6" data-id="element-112">
              Política de Privacidad
            </h2>
            <div className="text-gray-300 text-sm md:text-base space-y-4 leading-relaxed" data-id="element-113">
              <p data-id="element-114">
                En Infocommerce AI, nos comprometemos a proteger tu privacidad.
                Esta política describe cómo recopilamos, usamos y protegemos tu
                información personal.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-115">
                1. Información que Recopilamos
              </h3>
              <p data-id="element-116">
                Recopilamos información que nos proporcionas directamente,
                incluyendo:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-117">
                <li data-id="element-118">Nombre y dirección de correo electrónico</li>
                <li data-id="element-119">Información de registro del evento</li>
                <li data-id="element-120">Comunicaciones que mantienes con nosotros</li>
              </ul>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-121">
                2. Uso de la Información
              </h3>
              <p data-id="element-122">Utilizamos tu información para:</p>
              <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-123">
                <li data-id="element-124">
                  Proporcionar acceso al masterclass y materiales relacionados
                </li>
                <li data-id="element-125">Enviar comunicaciones sobre el evento</li>
                <li data-id="element-126">Mejorar nuestros servicios y contenido</li>
                <li data-id="element-127">Cumplir con obligaciones legales</li>
              </ul>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-128">
                3. Compartir Información
              </h3>
              <p data-id="element-129">
                No vendemos ni compartimos tu información personal con terceros
                para fines de marketing. Podemos compartir información con
                proveedores de servicios que nos ayudan a operar nuestro
                negocio.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-130">
                4. Seguridad de Datos
              </h3>
              <p data-id="element-131">
                Implementamos medidas de seguridad técnicas y organizativas
                apropiadas para proteger tu información personal contra acceso
                no autorizado, alteración o destrucción.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-132">
                5. Tus Derechos
              </h3>
              <p data-id="element-133">
                Tienes derecho a acceder, corregir o eliminar tu información
                personal. Para ejercer estos derechos, contáctanos en:{' '}
                <a href="mailto:support@truemarketer.com" className="text-green-500 hover:text-green-400" data-id="element-134">
                  support@truemarketer.com
                </a>
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-135">6. Cookies</h3>
              <p data-id="element-136">
                Utilizamos cookies y tecnologías similares para mejorar tu
                experiencia en nuestro sitio web y analizar el uso del sitio.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-137">Contacto</h3>
              <p data-id="element-138">
                Para preguntas sobre esta política de privacidad, contacta:{' '}
                <a href="mailto:support@truemarketer.com" className="text-green-500 hover:text-green-400" data-id="element-139">
                  support@truemarketer.com
                </a>
              </p>
            </div>
          </div>
        </div>}
    </div>;
}